/**
 * @desc 获取备注列表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderFacadeImpl.getOrderRemarkList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/getOrderRemarkList`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
